<div class="appliance-details-stepped-content-toggle__container">
  <p class="mb-4 mt-4">
    {{ textBefore }}
    <span (click)="contentToggle()" class="link">{{ toggleLabel }}</span>
  </p>
  <ng-container *ngIf="displayContent">
    <ng-content></ng-content>
  </ng-container>
</div>
